import DateTimePicker from "@react-native-community/datetimepicker";
import { useState } from "react";
import { Platform, Pressable, View } from "react-native";
import { control, spacing, useTheme } from "~/styles/theme";
import { formatDateOnly, parseDateOnly } from "~/utils/dates";
import { BodyText, CaptionText } from "./Text";

export function DateField({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const { colors } = useTheme();
  const [open, setOpen] = useState(Platform.OS === "ios");
  const date = parseDateOnly(value);

  return (
    <View style={{ gap: spacing.xxs }}>
      <CaptionText
        color={colors.muted}
        style={{ textTransform: "uppercase", letterSpacing: 0.6 }}
      >
        {label}
      </CaptionText>
      {Platform.OS === "ios" ? (
        <View
          style={{
            borderWidth: 1,
            borderColor: colors.ruleStrong,
            paddingHorizontal: spacing.xs,
          }}
        >
          <DateTimePicker
            value={date}
            mode="date"
            display="inline"
            themeVariant={colors.background === "#0a0a0a" ? "dark" : "light"}
            accentColor={colors.accent}
            onChange={(_event, selected) => {
              if (selected) onChange(formatDateOnly(selected));
            }}
          />
        </View>
      ) : (
        <>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel={`Date: ${value}`}
            onPress={() => setOpen(true)}
            style={{
              height: control.height,
              borderWidth: 1,
              borderColor: colors.ruleStrong,
              paddingHorizontal: spacing.sm,
              justifyContent: "center",
              backgroundColor: colors.surface,
            }}
          >
            <BodyText>{value}</BodyText>
          </Pressable>
          {open ? (
            <DateTimePicker
              value={date}
              mode="date"
              display="default"
              onChange={(event, selected) => {
                setOpen(false);
                if (event.type === "set" && selected) {
                  onChange(formatDateOnly(selected));
                }
              }}
            />
          ) : null}
        </>
      )}
    </View>
  );
}
